import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./css/Mobile.css"
import axios from "axios";
import jsonData from "../../component/ai-branding.json"; // Import the JSON file
import { useHyperlink } from "../../contexts/HyperlinkProvider";

const TopBanner = lazy(() => import("../Desktop/banner/TopBanner"));
// const Highlights = lazy(() => import("./Highlights"));
const VideoTestimonials = lazy(() => import("../VideoTestimonials"));
const NoOverlays = lazy(() => import("../Nooverlays/Nooverlays"));
const NumberNeverLie = lazy(() => import("../NumbersNeverLie/NumberNeverLie.js"));
const Highlights = lazy(() => import("../Highlights/Highlights"));
const Balancing = lazy(() => import("../Balancing/Balancing"));
const Quote = lazy(() => import("../Quote/Quote"));
const MobileJoinOurTeam = lazy(() => import("../JoinOurTeam/mobilejoinourteam"));
const Header = lazy(() => import("../Header"));
const Relieve = lazy(() => import("../NativeVideo/Relieve.js"));
const Patent = lazy(() => import("../patent/patent.js"));
const Footer = lazy(() => import("../CommenFooterComponent/index.js"));



export default function MobileView() {
    const imgCDNURL = process.env.REACT_APP_CDN_IMAGES;

	const [links, setLinks] = useState(null); // Set initial state as null
	const [angelAiLink, setAngelAiLink] = useState("");
	const [angelComLink, setAngelComLink] = useState("");
	const [sunwestLink, setSunWestLink] = useState("");
	const [sunwestLink1, setSunWestLink1] = useState("");
	const [celligenceLink, setCelligenceLink] = useState("");
	const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
	const [pavanLink, setPavanLink] = useState("");
	const { getHyperLink } = useHyperlink();
  
	useEffect(() => {
	  const processContent = async () => {
		const swLink = await getHyperLink("websites", "swmc", 1);
		const swLink1 = await getHyperLink("websites", "swmc", 0);
		const aiLink = await getHyperLink("websites", "angelai", 0);
		const aiComLink = await getHyperLink("websites", "angelai", 1);
		const cellLink = await getHyperLink("websites", "celligence", 1);
		const celliLlcLink = await getHyperLink("websites", "celligence", 0);
		const pavan = await getHyperLink("profiles", "pavan", 0);
		setAngelAiLink(aiLink || "AngelAi");
		setAngelComLink(aiComLink || "AngelAi.com");
		setSunWestLink(swLink || "Sun West Mortgage Company, Inc.");
		setSunWestLink1(swLink1 || "Sun West");
		setCelligenceLink(cellLink || "Celligence");
		setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
		setPavanLink(pavan || "Pavan Agarwal");
	  };
	  processContent();
	}, [getHyperLink]);

useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

    return (
			<div>
				  {links ? (
              <>
			<div className="bannerbg">
			<Suspense fallback={<div />}>
					<Header />
			</Suspense>
			<Suspense fallback={<div />}>
			<TopBanner sunwestLink={sunwestLink} sunwestLink1={sunwestLink1}/>
			</Suspense>
			</div>
			<Suspense fallback={<div />}>
					<Relieve />
			</Suspense>
			<Suspense fallback={<div />}>
					<NoOverlays />
			</Suspense>
			<Suspense fallback={<div />}>
					<NumberNeverLie />
			</Suspense>
			<Suspense fallback={<div />}>
			<Highlights links={links} angelAiLink={angelAiLink} sunwestLink1={sunwestLink1}/>
			</Suspense>
			<Suspense fallback={<div />}>
				<Balancing sunwestLink1={sunwestLink1} pavanLink={pavanLink}/>
			</Suspense>
			<Suspense fallback={<div />}>
				<Quote pavanLink={pavanLink}/>
			</Suspense>
			<Suspense fallback={<div />}>
					<MobileJoinOurTeam links={links}/>
			</Suspense>
			<Suspense fallback={<div />}>
					<VideoTestimonials />
			</Suspense>
			<Suspense fallback={<div />}>
					<Patent />
			</Suspense>
			<Suspense fallback={<div />}>
					<Footer links={links}/>
			</Suspense>
			</>
            ) : (
              <div>Loading...</div>
            )}
	</div>
    );
}